<template>
  <div class="slide-search">
    <div class="search-bar">
      <div class="btn-search" @click="slideSearch = true">{{ $t("base.search") }}</div>
      <div class="spacer"></div>
      <GisBtn v-if="gisurl" class="small-gis" :gisurl="gisurl"></GisBtn>
    </div>
    <transition name="left-slide">
      <div
        class="slide-wrapper"
        v-if="slideSearch"
      >
        <div class="search-main">
          <div class="input-filter" v-if="categoryList">
            <input
              type="button"
              class="search-input"
              v-model="category"
              @click="showCategoryMenu"
            >
            <div class="search-menu" v-if="categoryMenu">
              <div class="search-menu-item" @click="setCategory('全部分类')">全部分类</div>
              <div
                v-for="(item, index) in categoryList"
                :key="index"
                class="search-menu-item"
                @click="setCategory(item)"
              >{{item}}</div>
            </div>
          </div>
          <div class="input-filter">
            <input type="button" class="search-input" v-model="filterTitle" @click="showFilterMenu">
            <div class="search-menu" v-if="filterMenu">
              <div
                v-for="(item, index) in filterList"
                :key="index"
                class="search-menu-item"
                @click="setFilter(item.name)"
              >{{item.title}}</div>
            </div>
          </div>
          <div class="input-keywords">
            <input type="text" class="search-input" v-model="keywords" :placeholder="$t('base.enterkeywords')">
          </div>
          <div class="divider"></div>
          <div class="btn-submit" @click="submit">{{ $t("base.search") }}</div>
          <div class="btn-close" @click="slideSearch = false">{{ $t("base.cancel") }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GisBtn from "@/components/GisBtn";
export default {
  props: {
    gisurl: String,
    categoryList: Array,
    filterList: Array
  },
  components: {
    GisBtn
  },
  data() {
    return {
      slideSearch: false,
      categoryMenu: false,
      filterMenu: false,
      category: "全部分类",
      filter: "",
      keywords: ""
    };
  },
  computed: {
    filterTitle() {
      for (let value of this.filterList) {
        if (value.name === this.filter) {
          return value.title;
        }
      }
    }
  },
  mounted() {
    this.filter = this.filterList[0].name;
  },
  methods: {
    showCategoryMenu() {
      this.filterMenu = false;
      this.categoryMenu = !this.categoryMenu;
    },
    showFilterMenu() {
      this.categoryMenu = false;
      this.filterMenu = !this.filterMenu;
    },
    setCategory(category) {
      this.category = category;
      this.categoryMenu = false;
    },
    setFilter(filter) {
      this.filter = filter;
      this.filterMenu = false;
    },
    submit() {
      let data = {};

      if (this.category != "全部分类") {
        data.category = this.category;
      }

      if (this.keywords) {
        data[this.filter] = this.keywords;
      }

      if (Object.keys(data).length != 0) {
        this.$emit("search", data);
      } else {
        this.$emit("offsearch");
      }

      this.slideSearch = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.slide-search {
  padding: 0 1rem;

  .search-bar {
    display: flex;

    .btn-search {
      display: inline-block;
      padding-top: 0.25rem;
      color: $primary;
      font-size: 0.875rem;
      line-height: 1rem;

      &::before {
        content: "";
        display: inline-block;
        position: relative;
        top: 3px;
        width: 1rem;
        height: 1rem;
        margin-right: 0.3rem;
        background-image: url("~@/assets/img/icon-search.png");
        background-size: 100%;
      }
    }

    .spacer {
      display: inline-block;
      flex: 1;
    }

    .small-gis {
      width: 1.75rem;
      height: 1.75rem;
    }
  }
}

.slide-wrapper {
  @include pageset;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);

  .search-main {
    width: 12rem;
    height: 100%;
    padding: 4rem 2rem;
    background-color: $text-dark;

    .search-input {
      display: block;
      width: 100%;
      height: 2rem;
      padding-right: 1.5rem;
      text-align: center;
      color: $text;
      background-color: #e9ddbf;
      border: 1px solid rgba(0, 0, 0, 0.3);
      border-radius: 6px;
      box-sizing: border-box;
    }

    .search-menu {
      position: absolute;
      z-index: 50;
      top: 1rem;
      right: -3rem;
      padding: 0.5rem 0;
      background-color: #e9ddbf;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.4);

      .search-menu-item {
        min-width: 5rem;
        padding: 0.5rem 1rem;

        &:active,
        &:focus {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }

    .input-filter {
      position: relative;
      padding-top: 2rem;

      &::after {
        content: "";
        position: absolute;
        display: block;
        right: 1rem;
        top: 2.8rem;
        width: 0.7rem;
        height: 0.4rem;
        background-image: url("~@/assets/img/arrow-down.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    .input-keywords {
      margin-bottom: 0.5rem;
      padding-top: 2rem;
      .search-input {
        padding: 0;
      }
    }

    .btn-submit,
    .btn-close {
      margin-top: 1.5rem;
      padding: 0.5rem;
      font-size: 0.875rem;
      text-align: center;
      color: $text-dark;
      background-color: $primary;
      border-radius: 6px;
    }

    .btn-close {
      margin-top: 3rem;
      color: $text;
      background-color: transparent;
      border: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
